import $ from 'jquery';
import * as keyFunctionActions from './keyFunctionActions';
import * as receiptActions from './receiptActions';
import * as generalActions from './generalActions';
import * as paymentFunctions from '../functions/PaymentFunctions';
import * as modalActions from '../modal/actions/modalActions';
import * as ticketActions from '../ticket/actions/ticketActions';
import * as objectActions from '../objectmanagement/actions/objectManagementActions';
import * as types from '../constants/Types';
import * as itemAction from './layoutActions';
import * as invoiceActions from './invoiceActions';
import * as resources from '../constants/Resources';


export function SetPriceList(priceListId) {
    return (dispatch, getState) => {
        dispatch(receiptActions.setPriceList(priceListId));
        dispatch(receiptActions.updateReceiptLines(getState().receiptState.receipt.lines));
    }
}
export function AddArticle(articleId) {
    return (dispatch) => {
        dispatch(receiptActions.addArticleLine(articleId));
    }
}
export function SetCustomer(customer) {
    return (dispatch, getState) => {
        dispatch(receiptActions.setCustomer(customer.customerId, customer.customerName, customer.saldo, customer.allowAfterPay, customer.age, customer.customerGroupId, customer.customerGroup, customer.invoiceOnly, customer.discountPercentage));
        dispatch(receiptActions.setPriceList(customer.priceListId));
        dispatch(receiptActions.updateReceiptLines(getState().receiptState.receipt.lines));
        if (customer.invoiceOnly) {
            dispatch(invoiceActions.toggleInvoicingOnOff());
        }
    }
}

export function SetCardInserted(cardNumber) {
    return (dispatch, getState) => {
        dispatch(receiptActions.setCardName(cardNumber));
        dispatch(modalActions.setPaymentModalCardInserted(true));

        if (getState().receiptState.receipt.paymentdevice.paymentid > 0) {
            const paymentId = getState().receiptState.receipt.paymentdevice.paymentid;
            const receiptAmount = dispatch(receiptActions.getReceiptAmount());
            const paymentAmount = dispatch(paymentFunctions.getPaymentAmount());

            dispatch(paymentFunctions.startPaymentDevice(paymentId, paymentAmount, receiptAmount));
        }
    }
}

export function SetPaymentStatus(paymentStatus) {
    return (dispatch, getState) => {
        const paymentid = getState().receiptState.receipt.paymentdevice.paymentid;
        const paymentAmount = getState().receiptState.receipt.paymentdevice.paymentAmount;
        const receiptAmount = getState().receiptState.receipt.paymentdevice.receiptAmount;
        const posType = getState().generalState.posType;

        dispatch(receiptActions.setPaymentDevice(
            paymentid,
            paymentAmount,
            receiptAmount,
            (paymentStatus.status === types.PAYMENTSTATUS_BUSY),
            paymentStatus.message,
            paymentStatus.oldBalance,
            paymentStatus.newBalance
        ));

        const paymentParam = {
            paymentId: paymentid,
            paymentAmount,
            receiptAmount
        };

        if (paymentStatus.parameters !== null) {
            paymentParam.paymentDeviceParam = {
                brandName: paymentStatus.parameters.brandName,
                clientTicket: paymentStatus.parameters.ticketText
            };
        }

        switch (paymentStatus.status) {
            case types.PAYMENTSTATUS_SUCCESS:
                dispatch(paymentFunctions.finishPayment(paymentParam));
                dispatch(modalActions.setPaymentModal(false));
                break;
            case types.PAYMENTSTATUS_BUSY:
                break;
            case types.PAYMENTSTATUS_FAILED:
                if (posType === types.POSTYPE_CHARGINGKIOSK) {
                    setTimeout(() => { dispatch(modalActions.setPaymentModal(false)) }, 5000);
                    receiptActions.registerCustomerAction();
                } else {
                    dispatch(modalActions.setPaymentModal(false));
                    dispatch(generalActions.setMessageModal(true, paymentStatus.message || resources.PAYMENT_FAILED));
                }
                break;
            default:
                break;
        }
    }
}

export function SetArticleWeight(item) {
    return dispatch => {
        dispatch(modalActions.setWeightModalWeight(item.weight));
    }
}

export function SetScaleStatus(item) {
    return dispatch => {
        dispatch(modalActions.setScaleStatus(item.message));
    }
}

export function SetMessage(item) {
    return dispatch => {
        dispatch(generalActions.setMessageModal(true, item.message));
    }
}

export function UpdateObjectOverview(groupsJson) {
    return dispatch => {
        var groups = JSON.parse(groupsJson);
        dispatch(objectActions.receiveObjectGroupList(groups));
    }
}

export function UpdateKeyboardLayout(param) {
    return dispatch => {
        dispatch(itemAction.getLayouts());
    }
}

export function SetTicketValidated(result) {  
    return dispatch => {
        dispatch(ticketActions.validatedTicket(JSON.parse(result)));
    }
}

export function Login(posid) {
    return () => {
        if ($.connection !== undefined) {
            $.connection.invoke("joinGroup", `POS_${posid}`);
        }
    }
}

export function Logout(posid) {
    return () => {
        if ($.connection !== undefined) {
            $.connection.invoke("leaveGroup", `POS_${posid}`);
        }
    }
}

export function SetReservation(reservationJson) {
    return (dispatch, getState) => {
        var reservation = JSON.parse(reservationJson);
        dispatch(receiptActions.getReceiptByReservation(reservation));
        dispatch(modalActions.setReservationModal(true, reservation, getState().modalState.reservationModal.paymentParam));
    } 
}

export function SetObjectItem(objectItemJson) {
    return dispatch => {
        var objectItem = JSON.parse(objectItemJson);
        dispatch(keyFunctionActions.continueObjectManagementOpen(objectItem));
    } 
}



// WEBPACK FOOTER //
// src/actions/signalRActions.js